<template>
  <mu-card id="blood-pressure-input">
    <mu-card-text class="card-style" v-bind:class="{cardHasData: hasData}">
      <div v-if="loading">
        <mu-flexbox class="card-loading-padding" align="center" justify="center">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="56" color="#FFFFFF" :strokeWidth="5"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>
      <div v-if="!loading" class="animated fadeIn">
        <mu-flexbox v-if="data.no_setting || data.error" class="card-error-padding" justify="center">
          <mu-flexbox-item align="center">
            <div class="card-notice-title" v-text="$t('message.cardEmpty')"></div>
            <div>{{$t('message.cardTapPrefix')}}
              <mu-icon v-if="data.no_setting" class="card-icon-error" :size="16" slot="left" value="settings"/>
              <mu-icon v-if="data.error" class="card-icon-error" :size="16" slot="left" value="add"/>
              <span v-if="data.error || data.no_setting">{{$t('message.cardTapSuffix')}}</span>
            </div>
          </mu-flexbox-item>
        </mu-flexbox>
        <div v-else @click="goToDetail" style="cursor: pointer;">
          <span v-show="false">{{hasData = true}}</span>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">
                {{$t('message.cardLatestReading')}}
              </mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div class="card-large-stat">
                  <span v-text="data.latest_systolic + '/' + data.latest_diastolic + ' mmHG'"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block v-if="data.previous_systolic !== null">
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">
                {{$t('message.cardPreviousReading')}}
              </mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.previous_systolic + '/' + data.previous_diastolic + 'mmHG'"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <!--<mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">
                Pulse
              </mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.pulse + ' ' + data.measure"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>-->
        </div>
      </div>
    </mu-card-text>
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="10px" viewBox="20 195 16 10" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <!-- Generator: Sketch 39.1 (31720) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <path
            d="M32.000831,196.05636 C32.0007895,196.056319 32.0007064,196.056319 32.0006648,196.056278 C29.5330536,194.647969 26.4672788,194.647887 23.999626,196.056155 C23.9995014,196.056237 23.9993352,196.056278 23.9992105,196.05636 C21.6008227,197.424633 20,199.980785 20,202.890183 C20,203.059962 20.1395272,203.197531 20.31163,203.197531 L26.1818257,203.197531 C26.3304109,204.054991 27.0889184,204.709847 28,204.709847 C28.9149458,204.709847 29.6534259,204.084537 29.8156812,203.197531 L35.68837,203.197531 C35.8604728,203.197531 36,203.059962 36,202.890183 C36.0000416,199.979638 34.3982216,197.424059 32.000831,196.05636 L32.000831,196.05636 Z M28.0000416,204.095151 C27.326339,204.095151 26.7782441,203.554628 26.7782441,202.890183 C26.7782441,202.22668 27.3266298,201.685091 28.0001247,201.685091 C28.6587859,201.685091 29.2129056,202.206559 29.2215482,202.874118 C29.2187643,203.485085 28.7620809,204.095151 28.0000416,204.095151 L28.0000416,204.095151 Z M29.710558,202.195043 C29.655171,202.06272 29.583413,201.936707 29.4958242,201.819587 L30.3388873,201.602599 L29.710558,202.195043 L29.710558,202.195043 Z M30.2012715,202.582794 L31.6378444,201.228167 C31.8691985,201.00995 31.6538829,200.628962 31.3437903,200.708626 L29.334192,201.225872 L31.9554577,196.748098 C33.9382142,197.992776 35.2657581,200.135606 35.370258,202.582794 L30.2012715,202.582794 L30.2012715,202.582794 Z"
            id="Shape" stroke="none" fill="#FA6956" fill-rule="evenodd"></path>
        </svg>
        <mu-flexbox-item class="left16" v-text="loading ? $t('message.loadingText') : title"></mu-flexbox-item>
        <mu-flexbox-item align="right" v-bind:class="{invisible: isOpen}">
          <mu-icon-button
            :disabled="loading"
            v-if="!isOpenInput"
            v-tooltip.top="$t('message.addEntryText')"
            class="card-bar-icon"
            :icon="'add'"
            @click.native="openInput"
          ></mu-icon-button>
          <mu-icon-button
            :disabled="loading"
            v-if="isOpenInput"
            class="card-bar-icon"
            :icon="'remove'"
            @click.native="openInput"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
    <transition :css="false" @enter="onToggleEnter" @leave="onToggleLeave">
      <form @submit.prevent="saveReading" v-if="isOpenInput" v-bind:style="{height: computedAuto}"
            style="overflow: hidden;">
        <mu-card-text>
          <mu-row>
            <mu-col width="100" tablet="50" desktop="50">
              <mu-text-field
                type="number"
                min="30"
                max="300"
                v-validate
                data-vv-validate-on="none"
                data-vv-rules="required|min_value:30|max_value:300"
                data-vv-name="systolic"
                data-vv-value-path="inputValue"
                :data-vv-as="$t('message.labelSystolic')"
                :errorText="errors.first('systolic')"
                :label="$t('message.labelSystolic')"
                v-model.number="model.systolic"
                :hintText="$t('message.cardBloodPressuremmHGPlaceholder')"
                :fullWidth="true"
                :helpText="'mmHG'"
              />
            </mu-col>
            <mu-col width="100" tablet="50" desktop="50">
              <mu-text-field
                type="number"
                min="30"
                max="300"
                v-validate
                data-vv-validate-on="none"
                data-vv-rules="required|min_value:30|max_value:300"
                data-vv-name="diastolic"
                data-vv-value-path="inputValue"
                :data-vv-as="$t('message.labelDiastolic')"
                :errorText="errors.first('diastolic')"
                :label="$t('message.labelDiastolic')"
                v-model.number="model.diastolic"
                :hintText="$t('message.cardBloodPressuremmHGPlaceholder')"
                :fullWidth="true"
                :helpText="'mmHG'"
              />
            </mu-col>
          </mu-row>
          <!--<mu-row class="bottom">
            <mu-col width="100" tablet="50" desktop="50">
              <mu-text-field
                type="number"
                min="0"
                max="220"
                v-validate
                data-vv-validate-on="none"
                :data-vv-rules="'min_value:0|max_value:220'"
                data-vv-name="pulse"
                data-vv-value-path="inputValue"
                :errorText="errors.first('pulse')"
                label="PULSE"
                v-model.number="model.pulse"
                hintText="Enter pulse"
                :fullWidth="true"
                :helpText="'BPM'"
              />
            </mu-col>
          </mu-row>-->

          <mu-checkbox v-model="model.customDate" :label="$t('message.labelCustomDate')"></mu-checkbox>
          <date-picker v-if="model.customDate" type="datetime" v-model="model.date"></date-picker>
        </mu-card-text>
        <mu-card-actions align="right" style="overflow: hidden">

          <button type="submit" style="display: none"></button>

          <mu-flat-button
            :label="$t('message.discardText')"
            @click.native="closeInput"
            class="demo-flat-button"
          />
          <mu-flat-button
            @click.native="saveReading()"
            type="button"
            :disabled="isSaving"
            :label="isSaving ? $t('message.savingText'): $t('message.saveText')"
            class="demo-flat-button"
          />
        </mu-card-actions>
      </form>
    </transition>
  </mu-card>
</template>
<script>


  import { TweenMax, TweenLite, Power3, ScrollToPlugin } from 'gsap/all'
  import 'gsap/ScrollToPlugin'
  const plugins = [ ScrollToPlugin];


  import BloodPressureApi from '../../../../api/Tracking/BloodPressure'
  import ScrollerMixins from '../../../../mixins/ScrollerMixin'
  import CardAnimationMixin from '../../../../mixins/CardAnimationMixin'
  import DatePicker from "../../../DateTimePicker/DateTimePicker.vue";

  export default {
    components: {DatePicker},
    name: 'blood-pressure-input',
    mixins: [ScrollerMixins, CardAnimationMixin],
    data() {
      return {
        title: this.$t('message.cardBloodPressure'),
        isOpen: false,
        isOpenInput: false,
        isSaving: false,
        isBackgroundShown: true,
        hasData: false,
        noData: false,
        loading: true,
        data: {},
        value: [0, 5],
        model: {
          customDate: false
        }
      }
    },
    mounted() {
      let self = this;

      self.$EventBus.$on('bloodPressurePusherReceived', function (model) {
        self.$nextTick(function () {
          self.data = model;
          self.$forceUpdate();
        });
      });

      self.$EventBus.$on('bloodPressureReadingUpdated', function () {
        self.$store.commit('setBloodPressureCard', {})
        self.loadData();
      });

      self.loadData();
    },
    methods: {
      saveReading() {
        let self = this;
        self.isSaving = true;
        self.$validator.validateAll()
          .then(function (valid) {
            if (valid === true) {

              if (!_.has(self.model, 'date')) {
                self.model.date = moment().format();
              }

              BloodPressureApi.postBloodPressureTracking(self.model)
                .then(function (response) {
                  self.$store.commit('setBloodPressureCard', {});
                  self.$EventBus.$emit('bpReadingAdded');
                  self.$EventBus.$emit('updateGraph');
                  self.$toastr.success(self.$t('message.cardBloodPressureAdded'));
                  if (self.$route.name === 'Dashboard') {
                    TweenLite.to(self.scroller, 0.2, {
                      scrollTo: {
                        y: self.$el,
                        offsetY: 16
                      }
                    })
                  }
                  self.isSaving = false;
                  self.loadData()
                })
                .catch(function () {
                  self.isSaving = false;
                  self.loadData()
                })
            }
            else {
              self.isSaving = false;
            }
          })
          .catch(function () {
            self.isSaving = false;
          })
      },
      closeInput() {
        let self = this;
        self.isOpenInput = false;
        self.$gtag.event('Closed',{
          'event_category': 'BloodPressureCard',
          'event_label': 'Closed card',
          'value': 0
        });
        self.model = {}
      },
      openInput() {
        let self = this;
        self.isOpenInput = !self.isOpenInput;
        if (self.isOpenInput) {
          self.$gtag.event('Open',{
            'event_category': 'BloodPressureCard',
            'event_label': 'Opened card',
            'value': 0
          })
        }
        if (!self.isOpenInput) {
          self.$gtag.event('Closed',{
            'event_category': 'BloodPressureCard',
            'event_label': 'Closed card',
            'value': 0
          })
        }
        self.model = {}
      },
      loadData() {
        let self = this;
        self.loading = true;
        self.isOpenInput = false;
        self.model = {};
        if (_.has(self.$store.state.cards.bloodPressure, 'measure')) {
          self.loading = false;
          self.data = self.$store.state.cards.bloodPressure;
        }
        else {
          BloodPressureApi.getBloodPressureTrackingCard()
            .then(function (response) {
              const status = response.status;
              if (status === 200) {
                self.data = response.data;
                self.loading = false;
                self.$store.commit('setBloodPressureCard', response.data);
              }
              else {
                if (status === 201) {
                  self.data = response.data;
                  self.loading = false;
                }
              }
            });
        }
      },
      goToDetail() {
        let self = this;
        self.$router.push({
          path: '/tracking/blood-pressure/'
        })
      }
    },
    beforeDestroy() {
      this.$EventBus.$off('bloodPressureUpdated');
      this.$EventBus.$off('bloodPressurePusherReceived');
    }
  }
</script>
<style lang="less">
  @import "./blood-pressure.less";
</style>



// WEBPACK FOOTER //
// BloodPressure.vue?05ca68b7